import EmptyPlaceholder from "common/components/EmptyPlaceholder";
import { Button } from "common/components/ui/Button";

import NoResultsImage from "assets/images/empty-placeholders/lead-list-no-leads.png";

export default function NoResultsPlaceholder({
  onClear,
}: {
  onClear: () => void;
}) {
  return (
    <EmptyPlaceholder
      title="No leads found"
      subtitle="There were no results that match your criteria"
      imageSrc={NoResultsImage}
      actionComponent={<Button onClick={onClear}>Clear</Button>}
      className="py-20"
    />
  );
}
